/**
 * Detects if the current device is likely a mobile phone based on screen size and user agent
 * @returns true if device appears to be a mobile phone
 */
export function isMobileDevice(): boolean {
  // Check screen width - typical phone screens are < 768px
  const isMobileWidth = window.innerWidth < 768;
  
  // Check for small screen height
  const isMobileHeight = window.innerHeight < 768;
  
  // Check user agent for common mobile indicators
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  const mobileUserAgentPattern = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;
  const isMobileUserAgent = mobileUserAgentPattern.test(userAgent);
  
  // Consider it a phone if width is narrow OR (mobile user agent AND not a large screen)
  return isMobileWidth || (isMobileUserAgent && isMobileHeight);
}

/**
 * Gets a descriptive message about the current screen size
 * @returns A string describing whether the screen meets requirements
 */
export function getScreenSizeMessage(): string {
  const width = window.innerWidth;
  const height = window.innerHeight;
  
  if (isMobileDevice()) {
    return `Your screen (${width}x${height}px) appears to be a mobile device. This application requires a larger screen.`;
  }
  
  if (width < 1920 || height < 1080) {
    return `Your screen (${width}x${height}px) is smaller than the recommended 1080p (1920x1080px).`;
  }
  
  return `Your screen (${width}x${height}px) meets the recommended requirements.`;
}
